import { FeatureDialogConfiguration } from './feature-dialog-launcher.interface';

export class FeatureDialogService {
    private static _INSTANCE: FeatureDialogService;

    /**
     * FeatureDialogLauncher component instance used to open and close dialogs.
     */
    private _featureDialogLauncher: HTMLTiFeatureDialogLauncherElement;

    /**
     * This function can be used to close the open dialog.
     *
     * This is needed for 'blocking' dialogs and action buttons that close dialog.
     */
    public static async closeDialog() {
        return FeatureDialogService.getInstance()._getFeatureDialogLauncher().closeDialog();
    }

    /**
     * Singleton accessor - create once then reuse.
     */
    public static getInstance(): FeatureDialogService {
        if (!FeatureDialogService._INSTANCE) {
            FeatureDialogService._INSTANCE = new FeatureDialogService();
        }

        return FeatureDialogService._INSTANCE;
    }

    /**
     * Main function to open a dialog.
     * Uses the `ti-feature-dialog-launcher` instance to open a `ti-dialog`.
     *
     * @param config Dialog configuration object
     */
    public static async openDialog(config: FeatureDialogConfiguration) {
        return FeatureDialogService.getInstance()._getFeatureDialogLauncher().openDialog(config);
    }

    /**
     * This function can be used to update the content
     *
     * @param content JSXBase.HTMLAttributes<HTMLStencilElement> | JSXBase.HTMLAttributes<HTMLStencilElement>[]
     */
    public static async updateDialogContent(content: JSXBase.HTMLAttributes<HTMLStencilElement> | JSXBase.HTMLAttributes<HTMLStencilElement>[]) {
        return FeatureDialogService.getInstance()._getFeatureDialogLauncher().updateDialogContent(content);
    }

    /**
     * This function finds the feature dialog launcher element in the DOM
     * or if not found creates one and attaches it to the DOM.
     */
    private _getFeatureDialogLauncher(): HTMLTiFeatureDialogLauncherElement {
        if (this._featureDialogLauncher && this._featureDialogLauncher.isConnected) {
            return this._featureDialogLauncher;
        }

        this._featureDialogLauncher = document.querySelector('ti-feature-dialog-launcher');
        if (this._featureDialogLauncher) {
            return this._featureDialogLauncher;
        }

        this._featureDialogLauncher = document.createElement('ti-feature-dialog-launcher');
        document.querySelector('body').appendChild(this._featureDialogLauncher);
        return this._featureDialogLauncher;
    }
}
